export default function getSettings(settings?: IApplicationSetting): IApplicationSettingKeyed[] {
  if(!settings) { return [] }

  return Object.keys(settings)
    .map(key => ({ ...settings[key], key }))
}
